// angular import
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdminComponent } from './@theme/layouts/admin';
import { EmptyComponent } from './@theme/layouts/empty/empty.component';
import { PrivacyPolicy } from './pages/privacy-policy/privacy-policy';
import { AuthGuardChild } from './@theme/helpers/auth.guard';

const routes: Routes = [

  {
    path: '',
    component: EmptyComponent,
    children: [
      { path: '', redirectTo: 'welcome-page', pathMatch: 'full' },
      {
        path: 'welcome-page',
        loadComponent: () =>
          import('./pages/demo/welcome-pages/welcome-page/welcome-page').then(c => c.WelcomePage)
      },
      {
        path: 'welcome-page-login',
        loadComponent: () =>
          import('./pages/demo/welcome-pages/welcome-page2/welcome-page2').then(c => c.WelcomePage2)
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/demo/auth/authentication-1/login/login.component').then(c => c.LoginComponent)
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./pages/demo/auth/authentication-1/register/register.component').then(c => c.RegisterComponent)
      },
      {
        path: 'e-howeya',
        loadComponent: () =>
          import('./pages/demo/auth/authentication-1/e-howeya/e-howeya.component').then(c => c.EHoweyaComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/demo/auth/authentication-1/forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent)
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./pages/privacy-policy/privacy-policy').then(c => c.PrivacyPolicy)
      },
      {
        path: 'program-details',
        loadComponent: () =>
          import('./pages/services-details/services-details').then(c => c.ServicesDetailsComponent)
      },
      {
        path: 'loading',
        loadComponent: () =>
          import('./pages/loading/loading').then(c => c.Loading)
      },
    ]
  },

  // Authenticated routes under /pages
  {
    path: 'pages',
    component: AdminComponent,
    canActivateChild: [AuthGuardChild],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        data: { breadcrumb: null },
        loadComponent: () =>
          import('./pages/dashbord/dashbord.component').then(c => c.DashbordComponent)
      },
      {
        path: 'services/programme-amen/:id',
        data: { breadcrumb: null },
        loadComponent: () =>
          import('./pages/services/programme-amen/programme-amen').then(c => c.ProgrammeAmen)
      },
      {
        path: 'services/carte-traitement/:id',
        data: { breadcrumb: null },
        loadComponent: () =>
          import('./pages/services/carte-traitement/carte-traitement').then(c => c.CarteTraitement)
      },
      {
        path: 'services/table-aide-social/:id',
        data: { breadcrumb: null },
        loadComponent: () =>
          import('./pages/services/table-aide-social/table-aide-social').then(c => c.TableAideSocial)
      },
      {
        path: 'demo',
        loadComponent: () =>
          import('./pages/demo/demo').then(c => c.Demo)
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./pages/demo/tables/ag-grid-table/ag-grid-table-module').then(c => c.AgGridTableModule)
      },
      {
        path: 'table-mat',
        loadComponent: () =>
          import('./pages/demo/tables/material-table/material-table.component').then(c => c.MaterialTableComponent)
      },


    ]
  },

  // Unauthorized page
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/demo/maintenance/error-401/error-401.component').then(c => c.Error401Component)
  },

  // Catch-all 404 page (must be last)
  {
    path: '**',
    loadComponent: () =>
      import('./pages/demo/maintenance/error/error.component').then(c => c.ErrorComponent)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
